import on from './on/index.js';
import checkObjectType from './_helpers/checkobjecttype.js';
import debounce from './_helpers/debounce.js';
import forOwn from './_helpers/forown.js';
export default function onDebounce(object, names, givenCallback, givenDelay, triggerOnInit, context) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    context = triggerOnInit;
    triggerOnInit = givenDelay;
    givenDelay = givenCallback;
    givenCallback = names;
    names = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'onDebounce');
  }
  var isNamesVarArray = Array.isArray(names);
  // allow to pass name-handler object
  if (names && typeof names === 'object' && !isNamesVarArray) {
    forOwn(names, function (namesObjCallback, namesObjName) {
      return onDebounce(object, namesObjName, namesObjCallback, givenCallback, givenDelay, triggerOnInit);
    });
    return object;
  }
  var delay = typeof givenDelay === 'number' ? givenDelay : 0;
  var callback = debounce(givenCallback, delay);
  // allow to remove event listener py passing original callback to "off"
  callback._callback = givenCallback;
  callback._kind = 'debounce';
  return on(object, names, callback, triggerOnInit, context);
}